export enum EmailIntegration {
  Invoices = 'Send email on <strong> Invoice </strong> creation',
  Quotation = 'Send email on <strong> Quotation </strong> creation',
  CreditNote = 'Send email on <strong> Credit Note </strong> creation',
  DebitNote = 'Send email on <strong> Debit Note </strong> creation',
  Receipt = 'Send email on <strong> Receipt </strong> creation',
  Donations = 'Send email on <strong> Donations </strong> creation',
  RecurringDonations = 'Send email on <strong> Recurring Donations </strong> creation',
  DonationsInKind = 'Send email on <strong> Donations In Kind </strong> creation',
}
